import { observer } from 'mobx-react';
import * as React from 'react';
import { ChallengeType } from '@api/ChallengeClient';
import { SelectBox } from '@components/select-box';
import { injectTSDI } from '@core/tsdi';
import { ReactComponent as HighScore } from '../../../../../../assets/svg/icons/badge.svg';
import { ReactComponent as FinishIcon } from '../../../../../../assets/svg/icons/finish.svg';
import { PersonalRulesStore } from './personal-rules/store';
import { ChallengeRulesStore } from './store';

interface BoxItemProps {
    label: string;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    viewBox?: string;
    dataTestId?: string;
}

export const BoxItem = ({
    label,
    icon: Icon,
    viewBox,
    dataTestId
}: BoxItemProps) => (
    <div
        data-testid={dataTestId}
        className="flex h-[100px] min-w-[100px] flex-col items-center justify-center p-2.5"
    >
        <Icon viewBox={viewBox} className="mb-1 size-10 fill-current" />
        <span>{label}</span>
    </div>
);

interface ChallengeTypeSelectProps {
    disabled?: boolean;
}

export const ChallengeTypeSelect = observer(
    ({ disabled }: ChallengeTypeSelectProps) => {
        const { validateRules } = injectTSDI(ChallengeRulesStore);
        const {
            fields: { strategy }
        } = injectTSDI(PersonalRulesStore);

        return (
            <SelectBox
                label="Challenge type"
                options={[
                    {
                        label: 'High Score',
                        value: ChallengeType.HIGH_SCORE,
                        component: ({ label }) => (
                            <BoxItem
                                icon={HighScore}
                                label={label}
                                viewBox="-1 0 24 24"
                                dataTestId="challenge-type-highscore"
                            />
                        )
                    },
                    {
                        label: 'Race',
                        value: ChallengeType.RACE,
                        component: ({ label }) => (
                            <BoxItem
                                icon={FinishIcon}
                                label={label}
                                viewBox="-1 0 24 24"
                                dataTestId="challenge-type-race"
                            />
                        )
                    }
                ]}
                value={strategy.value}
                onChange={(value: ChallengeType) => {
                    strategy.onChange(value);
                    validateRules();
                }}
                error={strategy.error}
                helperText={
                    strategy.value === ChallengeType.HIGH_SCORE
                        ? 'highest score wins'
                        : 'whoever finishes first wins'
                }
                disabled={disabled}
                required
            />
        );
    }
);
